const locale = {
	DETAILS_WEBSITES_FIELD_TITLE: 'URL',
	DETAILS_WEBSITES_FIELD_DESCRIPTION: 'Description'
};

export default locale;
